module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX 服务端渲染")]), _vm._v(" "), _c('p', [_vm._v("目前支持 "), _c('code', [_vm._v("NUXT")]), _vm._v(" 渲染，可以参考例子："), _c('a', {
    attrs: {
      "href": "https://github.com/nuxt/nuxt.js/tree/dev/examples/with-vux"
    }
  }, [_vm._v("https://github.com/nuxt/nuxt.js/tree/dev/examples/with-vux")]), _vm._v("。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1006c42e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-1006c42e"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vux-server-render-support-18.vue
// module id = 2036
// module chunks = 193